var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.info ? _c("div", [_vm.type == 6 ? _c("a-alert", {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      message: _vm.$t("您的理赔申请已被拒绝，如果需要再次理赔，请重新发起报案"),
      description: _vm.$t("拒绝赔付理由") + ":" + _vm.info.policyInfo.rejectOpinion,
      type: "error"
    }
  }) : _vm._e(), _vm.info.policyInfo && _vm.info.policyInfo.auditOpinion && _vm.type != 6 ? _c("a-alert", {
    attrs: {
      type: "error",
      message: _vm.$t("请补充相关资料") + "-" + _vm.info.policyInfo.auditOpinion,
      banner: ""
    }
  }) : _vm._e(), _vm.info.policyInfo && _vm.info.policyInfo.auditOpinion && _vm.type == 6 ? _c("a-alert", {
    attrs: {
      type: "error",
      message: _vm.$t("备注") + "-" + _vm.info.policyInfo.auditOpinion,
      banner: ""
    }
  }) : _vm._e(), _vm.type != 10 ? _c("information", {
    attrs: {
      policyInfo: _vm.info.policyInfo
    }
  }) : _vm._e(), _vm.type != 10 ? _c("claims-info", {
    attrs: {
      claimsInfo: _vm.info.claimsInfo,
      policyNo: _vm.info.policyInfo.policyNo,
      type: "claim",
      nodeType: _vm.type
    }
  }) : _vm._e(), !(_vm.type < 7) || _vm.type == 0 ? _c("compensation-info", {
    attrs: {
      payoutInfo: _vm.info.payoutInfo
    }
  }) : _vm._e(), _vm.info.mailingInfo && _vm.info.mailingInfo.csCompany && (_vm.type < 6 || _vm.type == 0 || _vm.type == 10 && _vm.info.payoutInfo.status == 1) ? _c("mail-info", {
    attrs: {
      mailingInfo: _vm.info.mailingInfo
    }
  }) : _vm._e()], 1) : _vm._e();
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };